import { ArchetypeDefinition } from '../../archetypeTypes';

export const WISDOM_ARCHETYPES: ArchetypeDefinition[] = [
    {
        key: 'sage',
        name: 'Sage',
        description: 'Pattern recognition, stability, and informational density.',
        category: 'Wisdom',
        tags: ['clarity', 'analysis', 'structure'],
        weights: { stability: 0.4, edgeCount: 0.25, linguisticComplexity: 0.2, averageNodeEnergy: 0.15 }
    },
    {
        key: 'mentor',
        name: 'Mentor',
        description: 'Guidance through coherent patterns and calm energy.',
        category: 'Wisdom',
        tags: ['guidance', 'coherence', 'patience'],
        weights: { stability: 0.4, averageNodeEnergy: 0.2, linguisticComplexity: 0.2, nodeCount: 0.2 }
    },
    {
        key: 'scholar',
        name: 'Scholar',
        description: 'Information density and careful linkage of knowledge.',
        category: 'Wisdom',
        tags: ['knowledge', 'research', 'links'],
        weights: { edgeCount: 0.35, linguisticComplexity: 0.25, stability: 0.2, nodeCount: 0.2 }
    }
];


